import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { CusType , HomeRemindSystemVersion } from "@/api/home";
import { Loading } from "element-ui";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Token: localStorage.getItem("comm-token") || "",
    userInfo: {},
    MenusData: [],
    CusTypeFlag: 0,
    dataORchannel: 1,
    MenusState: 0,
    QDstate: true, //控制渠道前台入口
    jobState: 0,
    rsf: false,
    versionData: null,
    NoMessageNumber: 0,
  },
  mutations: {
    // 存取token
    SET_TOKEN(state, token) {
      state.Token = token;
      if (token) {
        localStorage.setItem("comm-token", token);
      } else {
        localStorage.removeItem("comm-token");
      }
      // //console.log(state.Token,"tokens")
    },
    // 退出登录
    OUT_LOGINI(state) {
      state.Token = "";
      // 清除本地缓存token
      localStorage.removeItem("comm-token");
      // 清除登录时间
      localStorage.removeItem("token-startTime");
      // 菜单
      localStorage.removeItem("MenusData");
      // 清除菜单状态
      sessionStorage.removeItem("ischage");
      sessionStorage.removeItem("ischagess");
      sessionStorage.removeItem("ischages");
      // localStorage.clear();
      state.Token = "";
      state.userInfo = {};
      state.MenusData = null;
      state.CusTypeFlag = null;
      state.dataORchannel = null;
      state.MenusState = 0;
    },
    // 存取用户信息
    SET_USERINFO(state, userinfo) {
      //console.log(userinfo, "userinfo");
      if (userinfo) {
        state.userInfo = userinfo;
        state.MenusState = 1;
        // //console.log(this.userInfo,"userInfo")
      } else {
        state.userInfo = {};
      }
    },
    MENUS_DATA(state, menusdata) {
      if (menusdata) {
        //console.log(menusdata,'menusdata');
        state.MenusData = menusdata;
      } else {
        state.MenusData = [];
      }
    },
    DATA_REPORTING_STATE(state, par) {
      if (par == 2) {
        state.dataORchannel = 2;
      }
    },
    // 渠道工作日常模块控制工作报表切换
    OPERATION_HISTORY(state) {
      state.jobState = 1;
    },
    // 渠道工作日常模块控制工作报表面包屑
    TO_HOME(state) {
      state.jobState = 0;
    },
    WACTH_QY_Sdk(state,numbers){
      console.log(numbers,'numbers');
      if(numbers == undefined){
        numbers = 0
      }
      state.NoMessageNumber = numbers
    },
    // 版本信息
    VERSION(state , par) {
      if(par){
        state.versionData = par
        console.log(par,state.versionData,'aaa');
        if (state.versionData.SystemRemark) {
          let versionName = state.versionData.SystemRemark;
          window.document.title = `鸿雁-归创通桥渠道数据综合管理系统(${versionName})`;
        }
      }
    }
    // 控制渠道首营信息的营业执照状态
    // BUS_lIC_MEN_STA(state, par){
    //   if(par){
    //     if(par == 1){
    //       // '../../../../../assets/channel/menu/OK1.png'
    //       state.BusinessLicenseMenusStateURL = par
    //       console.log(par,state.BusinessLicenseMenusStateURL,'par');
    //     }
    //   }

    // }
  },
  actions: {
    async CUS_TYPE({ commit, state }) {
      let loading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,0.3)",
      });
      let { code, data } = await CusType({
        // hpName: query
      });
      if (code == 0) {
        //console.log(state, "state");
        if (data.CusType == "") {
          state.CusTypeFlag = 1;
        } else if (data.CusType == "平台") {
          state.CusTypeFlag = 2;
        } else {
          state.CusTypeFlag = 3;
        }
        commit("CUS_TYPE");
      }
      loading.close();
    },
    async Version({ commit }) {
      let { code, data } = await HomeRemindSystemVersion();
      if (code == 0) {
        commit("VERSION", data);
      }
    },
  },
  modules: {},
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      reducer(val) {
        return {
          userInfo: val.userInfo,
          MenusData: val.MenusData,
          MenusState: val.MenusState,
          versionData: val.versionData
        };
      },
    }),
  ],
});
